var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('p',{staticClass:"xPadding titleModal"},[_vm._v(" "+_vm._s(_vm.$t("history.lastUpdated"))+" ")]),_c('VTableHistory',{attrs:{"headers":_vm.headers,"items":_vm.itemsForHistory}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }